import { useRef, useImperativeHandle, forwardRef, memo, useState, useEffect } from 'react';
import styles from './FJTextToSpeechPlayItem.module.less';
import classNames from 'classnames';
import FJPauseIcon from '../../../../assets/svg/ttv/section-pause.svg?react';
import FJPlayIcon from '../../../../assets/svg/ttv/section-play.svg?react';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';
import FJUtil from '../../../../util/FJUtil.js';
import FJMessageStore from '../../../../store/FJMessageStore.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';

const FJTextToSpeechPlayItem = (props, ref) => {
    const {
        audioUrl,
        className,
        style,
        onGenerate,
        isGenerating,
        updateIsPlay = () => {},
        updateCurrentTime = () => {},
        isEqual = true,
        onPlayClick = () => {},
        onEnded = () => {},
    } = props;
    const [isPlay, setIsPlay] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [useAudioUrl, setUseAudioUrl] = useState(audioUrl);
    const audioRef = useRef(null);
    const idRef = useRef(FJAudioPlayManager.createId());

    useEffect(() => {
        setUseAudioUrl(audioUrl);
    }, [audioUrl]);

    useImperativeHandle(ref, () => ({
        play: () => {
            _changePlay();
        },
        pause: () => {
            pause();
        },
        reset: () => {
            _reset();
        },
    }));

    useEffect(() => {
        updateIsPlay(isPlay);
    }, [isPlay]);

    const _reset = () => {
        if (audioRef.current) {
            audioRef.current.currentTime = 0;
        }
        pause();
    };

    const _beforeChangePlay = e => {
        onPlayClick();
        setTimeout(() => {
            _changePlay(e);
        }, 100);
    };

    const _changePlay = e => {
        e?.stopPropagation();

        if (!isEqual) {
            onGenerate && onGenerate();
            return;
        }

        setIsPlay(!isPlay);
        if (isPlay) {
            pause();
        } else {
            if (isError) {
                setIsLoading(true);
                setUseAudioUrl(FJUtil.getReloadNewUrl(audioUrl));
            } else {
                play();
            }
        }
    };

    const play = () => {
        FJAudioPlayManager.add(idRef.current, { pause: pause });
        audioRef.current?.play();
        setIsPlay(true);
    };

    const pause = () => {
        if (audioRef.current) {
            audioRef.current?.pause();
        }
        // audioRef.current = null;
        setIsPlay(false);
    };

    const _onEnded = () => {
        setIsPlay(false);
        if (audioRef.current) {
            audioRef.current.currentTime = 0;
        }
        pause();
        updateCurrentTime(0);
        onEnded();
    };

    const _onError = () => {
        setIsError(true);
        setIsLoading(false);
        if (isPlay) {
            setIsPlay(false);
            FJMessageStore.addMessage(FJLocalStore._('playback-failed-please-try-again'), 'error');
        }
    };

    const _onLoadedData = () => {
        setIsError(false);
        setIsLoading(false);
    };

    const _onLoadStart = () => {
        setIsLoading(true);
        setIsError(false);
        if (isPlay) {
            play();
        }
    };

    const _forbidEvent = e => {
        FJUtil.forbidEvent(e);
    };

    return (
        <div
            className={classNames(styles.box, className)}
            style={style}
            onClick={_beforeChangePlay}
            // onMouseDown={_forbidEvent}
        >
            {((isPlay && isLoading) || isGenerating) && <div className={styles.loading} />}
            {isPlay && <FJPauseIcon />}
            {!isPlay && <FJPlayIcon />}
            <audio
                src={useAudioUrl}
                ref={audioRef}
                onEnded={_onEnded}
                onError={_onError}
                onLoadedData={_onLoadedData}
                onLoadStart={_onLoadStart}
                onTimeUpdate={e => updateCurrentTime(e.target.currentTime)}
                preload='metadata'
            />
        </div>
    );
};

export default memo(forwardRef(FJTextToSpeechPlayItem));
